<template>

    <div class="desktop-container noselect">

        <mq-layout mq="lg" class="arrow-carrousel-container pointer">

            <img class="arrow-carrousel img-noselect" src="/img/icons/arrow-grey.svg" @click="swipeRight" alt="arrow left">

        </mq-layout>

        <div>

            <transition name="slide">

                <template v-for="(val, index) in witnesses" v-if="carrousselShow(index)">

                    <div

                            class="carrousel-container"
                            v-touch:swipe.left="swipeLeft"
                            v-touch:swipe.right="swipeRight"
                    >

                        <img class="carrousel-img img-noselect" alt="witness profile image" :src="getImage(index)">

                        <div class="citation-text">{{ getText(index) }}</div>

                        <div class="citation-name">{{ getName(index) }}</div>

                    </div>

                </template>

            </transition>

            <div class="btn-carrousel-container">


                <div class="page-controller pointer" :class="{ 'page-controller-active': carrousselShow(0) }"
                     @click="carrousselCounter = 999"></div>
                <div class="page-controller pointer" :class="{ 'page-controller-active': carrousselShow(1) }"
                     @click="carrousselCounter = 1000"></div>
                <div class="page-controller pointer" :class="{ 'page-controller-active': carrousselShow(2) }"
                     @click="carrousselCounter = 1001"></div>


            </div>

        </div>

        <mq-layout mq="lg" class="arrow-carrousel-container pointer">

            <img class="arrow-carrousel arrow-carrousel-right" src="/img/icons/arrow-grey.svg" @click="swipeLeft" alt="arrow right">

        </mq-layout>

    </div>

</template>

<script>

export default {

    name: 'landing-carrousel',

    data () {
        return {
            carrousselCounter: 999,
            witnesses: 2
        }
    },

    methods: {

        carrousselShow (index) {
            return this.carrousselCounter % this.witnesses === index
        },

        swipeLeft () {
            this.carrousselCounter = this.carrousselCounter + 1
        },

        swipeRight () {
            this.carrousselCounter = this.carrousselCounter - 1
        },

        getImage (index) {
            return `/img/landing/carrousel/photo-${index + 1}.jpg`
        },

        getText (index) {
            return this.$t(`landing_web_testimonial_${1 + index}`)
        },

        getName (index) {
            return this.$t(`landing_web_name_${1 + index}`)
        }
    }

}

</script>

<style scoped lang="scss">

    .carrousel-container {
        margin-top: 52px;
        width: 100%;
        background-color: $white;
        border-radius: 4px;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        @media screen and (min-width: $above-tablet-length) {
            max-width: 536px;
        }
    }

    .citation-text {
        font-size: 14px;
        font-weight: 600;
        line-height: 1.71;
        color: $aquamarine;
        margin: 96px 14px 0;
        min-height: 70px;
        font-style: italic;
        @media screen and (min-width: $above-tablet-length) {
            font-size: 24px;
            line-height: 1.46;
            letter-spacing: 1.2px;
            min-height: 105px;
        }
    }

    .citation-name {
        font-size: 14px;
        font-weight: 600;
        line-height: 1.71;
        text-align: right;
        color: $midnight;
        height: 24px;
        margin: 16px 14px 8px;
        @media screen and (min-width: $above-tablet-length) {
            font-size: 18px;
            font-weight: 500;
            line-height: 1.56;
            margin: 42px 32px 18px;
            height: 28px;
        }
    }

    .carrousel-img {
        width: 112px;
        height: 112px;
        position: absolute;
        top: -30px;
        border-radius: 100px;
        @media screen and (min-width: $above-tablet-length) {
            width: 108px;
            height: 108px;
        }
    }

    .btn-carrousel-container {
        width: 100%;
        height: 8px;
        margin-top: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .page-controller {
        width: 8px;
        height: 8px;
        opacity: 0.3;
        background-color: $white;
        border-radius: 100px;
        margin: 0 4px;
        @media screen and (min-width: $above-tablet-length) {
            background-color: $midnight;
        }
    }

    .page-controller-active {
        opacity: 1;
    }

    .desktop-container {
        @media screen and (min-width: $above-tablet-length) {
            display: flex;
            flex-direction: row;
            align-items: center;
        }
    }

    .arrow-carrousel-container {
        width: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .arrow-carrousel {
        width: 24px;
        height: 24px;
    }

    .arrow-carrousel-right {
        transform: rotate(180deg);
    }

    /*animations*/

    .slide-leave-active {
        transition: 0.3s;
    }

    .slide-enter-active {
        transition: 0.1s;
    }

    .slide-enter {
        transform: translate(0, 100%);
    }

    .slide-leave-to {
        transform: translate(0, 100%);
    }

</style>
